export function instrumentRobotsDirective({ loading, error }) {
  return !loading && error === "not_found"
    ? "noindex, follow, noarchive"
    : undefined;
}

export function instrumentCanonicalPath({ slug, loading, error, lang = "id" }) {
  if (instrumentRobotsDirective({ loading, error })) return null;
  return lang === "en" ? `/en/instruments/${slug}` : `/instruments/${slug}`;
}

// The server marks HTML it rendered for a published instrument. When that
// marker matches the slug, an API 404 seen by the client (for example a stale
// response cached by Google's renderer) must not downgrade an indexable page
// to noindex: the server already answers a real 404 for missing instruments.
export const SERVER_INSTRUMENT_META = "mindovia-instrument";

export function serverConfirmedInstrument(slug, doc = globalThis.document) {
  const marker = doc?.querySelector?.(`meta[name="${SERVER_INSTRUMENT_META}"]`);
  return Boolean(slug) && marker?.getAttribute("content") === slug;
}

export function instrumentRequestFailure(error, { serverConfirmed = false } = {}) {
  return error?.response?.status === 404 && !serverConfirmed ? "not_found" : "unavailable";
}

// English pages use the optional English cover; otherwise everyone sees the Indonesian one.
export const instrumentCoverSrc = (instrument, lang) =>
  (lang === "en" && instrument?.cover_image_en) || instrument?.cover_image || "";
export const instrumentCoverImage = (instrument, lang) => instrumentCoverSrc(instrument, lang) || "/og-cover.png";
